module.exports = __webpack_public_path__ + "img/YannickTP-logo.597b0c23.png";